import { useMutation } from 'react-query';

import { useCompany } from 'src/core/modules/app/hooks/useCompany';
import { apiUrl } from 'src/core/utils/api';

export const useCustomFieldValuesSearch = (customFieldId: string) => {
  const company = useCompany();

  return useMutation(
    ['custom-fields', { customFieldId }, 'values'],
    async (query: string): Promise<{ key: string; label: string }[]> => {
      const response = await fetch(
        apiUrl(
          `/custom-fields/${customFieldId}/values?search=${encodeURIComponent(
            query,
          )}`,
          company.id,
        ),
        {
          method: 'GET',
          credentials: 'include',
        },
      );
      if (!response.ok) {
        return [];
      }
      const json = await response.json();
      return (json?.custom_fields_values ?? []).map(
        (result: { id: string; value: string }) => ({
          key: result.id,
          label: result.value,
        }),
      );
    },
    {
      retry: false,
    },
  );
};
